import { articleNewPath, mediaAnalysisHistoryPath } from '@/common/app/path'
import { MediaAnalysisStatus, MediaAnalysisType } from '@/common/model/media/mediaAnalysis'

import { BadgeType } from '@/components/view/atoms/badge/Badge'

// 分析タイプの表示名（サイト現状分析9種別は backend/routers/media_analysis.py の
// ANALYSIS_TYPE_DEFS のラベルと一致させる）
const ANALYSIS_TYPE_LABELS: Record<MediaAnalysisType, string> = {
  content_gap: 'コンテンツギャップ分析',
  keyword_analysis: 'キーワード分析',
  competitor: '競合分析',
  competitor_serp: 'SERP分析',
  cannibalization: 'カニバリ分析',
  link_structure: '内部リンク分析',
  citation: 'サイテーション分析',
  share_of_voice: 'シェア・オブ・ボイス分析',
  sentiment: 'センチメント分析',
  query_fanout: 'クエリファンアウト分析',
  timeline_link_structure: '内部リンク分析（タイムライン）',
  timeline_cannibalization: 'カニバリ分析（タイムライン）'
}

export const analysisTypeLabel = (type: MediaAnalysisType | null | undefined): string =>
  (type && ANALYSIS_TYPE_LABELS[type]) || type || '-'

// 分析の実行状態（backend/models.py の MediaAnalysisStatus と対応する）の表示名。
// 検索条件の選択肢と一覧の状態バッジで共用する
const ANALYSIS_STATUS_LABELS: Record<MediaAnalysisStatus, string> = {
  analyzing: '分析中',
  completed: '完了',
  failed: '失敗'
}

export const ANALYSIS_STATUSES = Object.keys(ANALYSIS_STATUS_LABELS) as MediaAnalysisStatus[]

export const analysisStatusLabel = (status: MediaAnalysisStatus | null | undefined): string =>
  (status && ANALYSIS_STATUS_LABELS[status]) || status || '-'

export const analysisStatusBadgeType = (status: MediaAnalysisStatus | null | undefined) => {
  switch (status) {
    case 'analyzing':
      return BadgeType.CAUTION
    case 'failed':
      return BadgeType.CRITICAL
    default:
      return BadgeType.SUCCESS
  }
}

// サイト現状分析9種別のkey一覧
const SITE_ANALYSIS_TYPES = [
  'competitor',
  'competitor_serp',
  'content_gap',
  'cannibalization',
  'link_structure',
  'citation',
  'share_of_voice',
  'sentiment',
  'query_fanout'
]

// 分析タイプ → 履歴を確認できる画面のパス（historyIdは持たないため一覧画面へ）
export const analysisTypeHistoryPath = (siteId: number, type: string): string | null => {
  switch (type) {
    case 'keyword_analysis':
    case 'article_generate':
    case 'draft_check':
    case 'child_articles':
      return articleNewPath(siteId)
    default:
      return SITE_ANALYSIS_TYPES.includes(type)
        ? `${mediaAnalysisHistoryPath(siteId)}?type=${type}`
        : null
  }
}

// ダッシュボード内の「実行する」ボタンの遷移先（page スラッグ → パス）
export const dashboardPagePath = (siteId: number, page: string): string =>
  `/sites/${siteId}/${page}`

export const mediaAnalysisImage = (type: MediaAnalysisType): string => {
  switch (type) {
    case MediaAnalysisType.COMPETITOR:
      return '/assets/media-analysis/competitor.png'
    case MediaAnalysisType.COMPETITOR_SERP:
      return '/assets/media-analysis/serp.png'
    case MediaAnalysisType.CONTENT_GAP:
      return '/assets/media-analysis/content-gap.png'
    case MediaAnalysisType.CANNIBALIZATION:
      return '/assets/media-analysis/cannibalization.png'
    case MediaAnalysisType.LINK_STRUCTURE:
      return '/assets/media-analysis/link-structure.png'
    case MediaAnalysisType.CITATION:
      return '/assets/media-analysis/citation.png'
    case MediaAnalysisType.SHARE_OF_VOICE:
      return '/assets/media-analysis/share-of-voice.png'
    case MediaAnalysisType.SENTIMENT:
      return '/assets/media-analysis/sentiment.png'
    case MediaAnalysisType.QUERY_FANOUT:
      return '/assets/media-analysis/query-fanout.png'
    default:
      return '/images/media/default.png'
  }
}
